module.exports = __webpack_public_path__ + "cc59a74f48b387c5c1848ba2ecdd4535.svg";